var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Notification / Black / Default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification-/-Black-/-Default",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.000000, 0.000000)",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "alarm-bell"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,21.75 C7.26088598,22.6387095 8.07628944,23.2491541 9.0025,23.2491541 C9.92871056,23.2491541 10.744114,22.6387095 11.005,21.75",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 3,
    x2: 9,
    y2: 0.75,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,3 C13.1421356,3 16.5,6.35786438 16.5,10.5 C16.5,17.546 18,18.75 18,18.75 L0,18.75 C0,18.75 1.5,16.834 1.5,10.5 C1.5,6.35786438 4.85786438,3 9,3 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.4f9e8386b92549cfa6f4f6f9372927e5.svg";
export { ForwardRef as ReactComponent };